import { CFDIFiscalRegimes } from "@app/interfaces/cfdi";

export const CFDI4_REGIMES: CFDIFiscalRegimes = {
   natural: [
     { value: '605', viewValue: 'Sueldos y salarios e ingresos asimilados a salarios' },
     { value: '606', viewValue: 'Régimen de Arrendamiento' },
     { value: '607', viewValue: 'Enajenación de bienes'},
     { value: '608', viewValue: 'Demás ingresos' },
     { value: '610', viewValue: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
     { value: '611', viewValue: 'Ingresos por Dividendos' },
     { value: '612', viewValue: 'Personas Físicas con Actividades Empresariales y Profesionales' },
     { value: '614', viewValue: 'Intereses' },
     { value: '615', viewValue: 'Obtención de premios' },
     { value: '616', viewValue: 'Sin obligaciones fiscales' },
     { value: '621', viewValue: 'Incorporación Fiscal' },
     { value: '625', viewValue: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas' },
     { value: '626', viewValue: 'Régimen Simplificado de Confianza' },

   ],
   legalEntity: [
     { value: '601', viewValue: 'General de Ley Personas Morales' },
     { value: '603', viewValue: 'Personas Morales con Fines no Lucrativos' },
     { value: '610', viewValue: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
     { value: '620', viewValue: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
     { value: '622', viewValue: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras' },
     { value: '623', viewValue: 'Opcional para Grupos de Sociedades' },
     { value: '624', viewValue: 'Coordinados' },
     { value: '626', viewValue: 'Régimen Simplificado de Confianza' },
   ]
 };
